<template>
    <modal name="memoUpdate" @before-open="beforeOpen" :adaptive="true" width="100%" height="100%">
        <div class="memo_wrap">
            <div class="memo_cont">
                <ul class="memo_txt">
                    <li><i class="fas fa-edit"></i>학습 중 메모를 자유롭게 남길 수 있는 공간입니다.</li>
                    <li><i class="fas fa-edit"></i>사이트 이용 및 기타문의는 1:1 문의에 남겨주시기 바랍니다. 답변은 1:1문의 게시판에서 확인이 가능합니다.</li></h3>
                    <li><i class="fas fa-edit"></i>교육내용에 대한 질문은 튜터문의에 남겨주시면 튜터강사님이 직접 답변해 드립니다.</li>
                </ul>
                <textarea v-model="memo" cols="30" rows="10">
                </textarea>
                <div class="memobt_wrap">
                    <input type="button" class="memobt" value="수정" @click="save()">
                    <input type="button" class="memobt" value="취소" @click="closeModal()"> 
                    <input type="button" class="memobt" value="목록" @click="getList()">
                </div>
            </div>
        </div> 
    </modal>
</template>
<script>
export default {
    data(){
        return{
            idx : null,
            memo : '',
        }
    },
    methods:{
        beforeOpen (event) {
            this.idx = event.params.idx;
            this.memo = event.params.memo;
            // this.memo = event.
        },
        save(){
            // send Progress to parent
            if(this.memo.length < 5){
                swal('알림','내용이 너무 짧습니다.','info');
                return;
            }
            window.parent.postMessage({
                type : 'studyContetnsMemoUpdateRequest',
                memo : this.memo,
                idx : this.idx
            },'*');
        },
        getList(){
            this.$modal.hide('memoUpdate');
            this.$modal.show('memoList'); 
        },
        closeModal(){
            this.$modal.hide('memoUpdate');
            // if(confirm ('취소하시겠습니까?')){
            // }
        },
    },
    mounted(){
        window.addEventListener("message",(e) => {
            if(e.data.type == "studyContetnsMemoUpdateResult"){
                if(e.data.response.result == 'success'){
                    this.closeModal();
                    swal('알림','성공적으로 수정되었습니다.','success');
                }else{
                    swal('알림',e.data.response.message,'error');
                }
            }else{
            }
        },false);
    }
}
</script>